<template>
  <div class="brl-top scroll-hidden">
    <global-loading v-if="$store.state.vaStore.department_in_charge_loading" />
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" v-if="levelChart == 1" @click="downloadReport()"></i>
      <i class="fa-solid fa-circle-arrow-left" style="color:red" v-else @click="backLevel1()"></i>
    </div>
    <div class="text-sm text-bold">
      Total Spend Category VS Department in Charge
    </div>
    <div class="mt10">
      <div class="brl-top-table-header border-bottom">
        <div class="brl-top-table-vendor">
          Department
          <span class="pointer" @click="departmentSortFunction()">
            <i class="fas fa-arrow-down" v-show="departmentSort"></i><i class="fas fa-arrow-up"
              v-show="!departmentSort"></i>
          </span>
        </div>

        <div class="brl-top-table-material">
          {{ levelChart == 1 ? 'Material Group' : 'Material Group' }}
          <span class="pointer" @click="materialSortFunction()">
            <i class="fas fa-arrow-down" v-show="materialSort"></i><i class="fas fa-arrow-up"
              v-show="!materialSort"></i>
          </span>
        </div>

        <div class="brl-top-table-value">
          Total Value USD
          <span class="pointer" @click="usdSortFunction()">
            <i class="fas fa-arrow-down" v-show="usdSort"></i><i class="fas fa-arrow-up" v-show="!usdSort"></i>
          </span>
        </div>
      </div>
      <div v-if="levelChart == 1">
        <div class="brl-top-table-header" v-for="(item, index) in material" :key="index">
          <div class="brl-top-table-vendor text-left">
            {{ item.purch_group_desc }}
          </div>

          <div class="brl-top-table-material pointer col-elipsis" @click="goLevel2(item)">
            {{ item.material_group_desc }}
          </div>

          <div class="brl-top-table-value">
            <div class="brl-display-value">
              {{ curencyDelimiter(item.total_value_usd) }}
            </div>
            <div class="brl-bar-chart" :style="`width: calc(100% - ${maxValueMaterial(item.total_value_usd)}%)`
              "></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="brl-top-table-header" v-for="(item, index) in material" :key="index">
          <div class="brl-top-table-vendor col-elipsis" style="text-align: left;">
            {{ item.purch_group_desc }}
          </div>

          <div class="brl-top-table-material">
            {{ item.material_group_desc }}
          </div>

          <div class="brl-top-table-value">
            <div class="brl-display-value">
              {{ curencyDelimiter(item.total_value_usd) }}
            </div>
            <div class="brl-bar-chart" :style="`width: calc(100% - ${maxValueMaterial(item.total_value_usd)}%)`
              "></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'

export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      materialSort: false,
      departmentSort: false,
      usdSort: false,
    }
  },
  created() {
    // this.$store.dispatch('vaStore/getTotalDepartmentInCharge')
  },
  computed: {
    material() {
      const data = this.$store.state.vaStore.department_in_charge
      return data
    },
    levelChart() {
      return this.$store.state.vaStore.department_in_charge_level
    },
  },
  methods: {
    materialSortFunction() {
      this.materialSort = !this.materialSort
      this.departmentSort = false
      this.usdSort = false
      let data = []
      if (this.materialSort) {
        data = _.sortBy(
          this.material,
          this.levelChart == 1 ? 'material_group_desc' : 'sub_material_name'
        )
      } else {
        data = _.sortBy(
          this.material,
          this.levelChart == 1 ? 'material_group_desc' : 'sub_material_name'
        ).reverse()
      }

      this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'department_in_charge',
        value: data,
      })
    },
    departmentSortFunction() {
      this.materialSort = false
      this.departmentSort = !this.departmentSort
      this.usdSort = false

      let data = []
      if (this.departmentSort) {
        data = _.sortBy(this.material, 'purch_group_desc')
      } else {
        data = _.sortBy(this.material, 'purch_group_desc').reverse()
      }

      this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'department_in_charge',
        value: data,
      })
    },
    usdSortFunction() {
      this.materialSort = false
      this.departmentSort = false
      this.usdSort = !this.usdSort

      let data = []
      if (this.usdSort) {
        data = this.material.sort(
          (a, b) => b.total_value_usd - a.total_value_usd
        )
      } else {
        data = this.material.sort(
          (a, b) => a.total_value_usd - b.total_value_usd
        )
      }

      this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'department_in_charge',
        value: data,
      })
    },
    async backLevel1() {
      await this.$store.dispatch('vaStore/getTotalDepartmentInCharge')
    },
    async goLevel2(data) {
      await this.$store.dispatch('vaStore/getDetailTotalDepartmentInCharge', {
        mat: data.purch_group,
      })
    },
    maxValueMaterial(value) {
      if (this.material && this.material.length > 0) {
        // return Object.values(value).reduce((a, b) => Number(a) + Number(b))
        const maxValue = Math.max(...this.material.map(o => o.total_value_usd))
        return 100 - (value / maxValue) * 100
      }
      return 0
    },
    async downloadReport() {
      let dateReport = moment().format('DDMMYY')
      let daterange = ''
      let start = this.$store.state.vaStore.start
      let end = this.$store.state.vaStore.end

      if (start && end) {
        daterange += `${start} - ${end}`
      }

      const total = await this.$store.dispatch(
        'vaStore/getTotalDepartmentInChargeTotal'
      )
      total.unshift({})
      const detail = await this.$store.dispatch(
        'vaStore/getTotalDepartmentInChargeDetail'
      )
      detail.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = ['Summary', 'Detail']

      sheet.forEach(list => {
        if (list == 'Summary') {
          let data = XLSX.utils.json_to_sheet(total)
          const title = [
            [
              `Total_Spend_Category_vs_Departement_in_Charge_Summary_${dateReport}`,
              daterange,
              '',
              '',
              '',
              '',
            ],
            [
              'ID Department',
              'Nama Department',
              'Material Group',
              'Material Group Desc',
              'Total Transaksi',
              'Total Value USD',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        } else {
          let data = XLSX.utils.json_to_sheet(detail)
          const title = [
            [
              `Total_Spend_Category_vs_Departement_in_Charge_Detail_${dateReport}`,
              daterange,
              '',
              '',
              '',
              '',
              '',
            ],
            [
              'ID Department',
              'Nama Department',
              'Material Group',
              'Material Group Desc',
              'Material Number',
              'Material Desc',
              'VALUE USD',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        }
      })
      XLSX.writeFile(wb, 'REPORT_TOTAL_SPEND_CATEGORY_DEPARTMENT_INCHARGE.xlsx')
    },
  },
}
</script>
<style scoped>
.region-container {
  width: 30%;
  font-size: 14px;
  font-weight: bold;
  border-top: 0.5px solid rgba(128, 128, 128, 0.3);
  border-right: 0.5px solid rgba(128, 128, 128, 0.3);
  text-align: right;
  padding-right: 5px;
}

.custom-bar-container {
  width: 70%;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.custom-bar-box {
  display: flex;
  height: 15px;
}

.custom-bar-color {
  border: 0.3px solid rgba(255, 192, 203);
  background: rgb(204, 0, 0);
  background: linear-gradient(90deg,
      rgba(204, 0, 0, 0.5) 0%,
      rgba(204, 0, 0, 0.3) 50%,
      rgba(255, 255, 255, 0.5) 100%);
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.region-value {
  font-size: 12px;
}
</style>
